import { render, staticRenderFns } from "./ExpandedItem.vue?vue&type=template&id=0fda78c9&scoped=true"
import script from "./ExpandedItem.vue?vue&type=script&lang=ts"
export * from "./ExpandedItem.vue?vue&type=script&lang=ts"
import style0 from "./ExpandedItem.vue?vue&type=style&index=0&id=0fda78c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda78c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fda78c9')) {
      api.createRecord('0fda78c9', component.options)
    } else {
      api.reload('0fda78c9', component.options)
    }
    module.hot.accept("./ExpandedItem.vue?vue&type=template&id=0fda78c9&scoped=true", function () {
      api.rerender('0fda78c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/ExpandedItem.vue"
export default component.exports